module.exports = __webpack_public_path__ + "media/images/kyronlogo-2456001b.svg";